<dashlet-table
    [columns]="columns"
    [dataSource]="servers$ | async"
    [tableHeightRows]="dashlet.tableHeightRows"
    [sortDirection]="'desc'"
    [loading]="loading"
    defaultSort="severity"
></dashlet-table>
